import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import { InPlaceEditText } from "../../inputs"

const addNewTabStyle = {
  border: "none",
}

const getActiveTabStyleRules = (colour) => {
  return `color: ${colour}!important; border-bottom-color: ${colour}!important;`
}

const TabLink = styled.a`
  ${props => props.customColour && getActiveTabStyleRules(props.customColour)};
`

function Tabs({
  t,
  tabDetails,
  onTabChange,
  activeTab,
  addNewTab,
  charactersToDisplay,
  deleteEvent,
  updateTab,
  theme,
  smallTabHeaderText,
}) {
  const handleDeleteClick = (tab) => {
    deleteEvent(tab)
  }

  const confirmTextEditChanges = (tab, text) => {
    tab.name = text
    updateTab(tab)
  }

  const doTabChange = (e, callback) => {
    preventDefault(e)
    callback()
  }

  const preventDefault = (e) => {
    e.preventDefault()
  }

  const tabHeaderSizeCssClass = smallTabHeaderText ? "small-tab-header " : ""

  return (
    <Fragment>
      <ul className="nav nav-tabs customtab">
        {tabDetails.map((tab) => {
          const boundClick = onTabChange.bind(this, tab)
          const isActiveTab = tab.id === activeTab

          return (
            <li className="nav-item" key={tab.id} onDragStart={preventDefault}>
              <TabLink
                customColour={isActiveTab ? theme.primaryColor : null}
                href=""
                onClick={e => doTabChange(e, boundClick)}
                className={
                  tabHeaderSizeCssClass +
                  (isActiveTab ? "btn btn-link nav-link active" : "btn nav-link btn-link")
                }
              >
                <span>
                  {isActiveTab && (
                    <InPlaceEditText
                      staticText={
                        charactersToDisplay
                          ? t(tab.name).substr(0, charactersToDisplay)
                          : t(tab.name)
                      }
                      onConfirmClick={updateTab ? evt => confirmTextEditChanges(tab, evt) : null}
                    />
                  )}
                  {!isActiveTab && (
                    <span>
                      {charactersToDisplay
                        ? t(tab.name).substr(0, charactersToDisplay)
                        : t(tab.name)}
                    </span>
                  )}
                  &nbsp;
                </span>
                &nbsp;
                {isActiveTab &&
                  tab.allowDelete &&
                  deleteEvent && (
                    <span className="fa fa-trash-o" onClick={evt => handleDeleteClick(tab, evt)} />
                  )}
              </TabLink>
            </li>
          )
        })}
        {addNewTab ? (
          <li className="nav-item">
            <button className="btn btn-link nav-link" style={addNewTabStyle} onClick={addNewTab}>
              <span className="fa fa-plus-circle" />
            </button>
          </li>
        ) : null}
      </ul>
    </Fragment>
  )
}

Tabs.propTypes = {
  t: PropTypes.func.isRequired,
  tabDetails: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }))
    .isRequired,
  onTabChange: PropTypes.func.isRequired,
  activeTab: PropTypes.number.isRequired,
  addNewTab: PropTypes.func,
  charactersToDisplay: PropTypes.number,
  smallTabHeaderText: PropTypes.bool,
}

Tabs.defaultProps = {
  addNewTab: null,
  charactersToDisplay: null,
  smallTabHeaderText: false,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(Tabs)



// WEBPACK FOOTER //
// ./src/components/layout/navigation/Tabs.jsx